import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex align-center justify-space-between" }

import { computed, watch } from 'vue';
import { useCortonaViewerStore } from '@/stores/cortonaViewer';


export default /*@__PURE__*/_defineComponent({
  __name: 'Toast',
  setup(__props) {

const cortonaViewerStore = useCortonaViewerStore();

const toast = computed(() => cortonaViewerStore.toast);

let timeout: ReturnType<typeof setTimeout> | null = null;

const hideToast = () => {
  cortonaViewerStore.hideToast();
};

const copyToClipboard = () => {
  if (toast.value.copyText) {
    navigator.clipboard.writeText(toast.value.copyText);
  }
};

watch(() => toast.value.visible, (newValue) => {
  if (newValue) {
    timeout = setTimeout(() => hideToast(), toast.value.timeout);
  } else if (timeout) {
    clearTimeout(timeout);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_alert = _resolveComponent("v-alert")!

  return (toast.value.visible)
    ? (_openBlock(), _createBlock(_component_v_alert, {
        key: 0,
        type: toast.value.type,
        class: "toast-alert",
        border: "start",
        closable: "",
        "onClick:close": hideToast
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("span", null, _toDisplayString(toast.value.message), 1 /* TEXT */),
            (toast.value.copyText)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  icon: "",
                  variant: "plain",
                  size: "x-small",
                  onClick: _withModifiers(copyToClipboard, ["stop"]),
                  class: "ml-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { size: "small" }, {
                      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                        _createTextVNode("mdi-content-copy", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true)
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["type"]))
    : _createCommentVNode("v-if", true)
}
}

})